export default __webpack_public_path__ + "static/media/GoLogo@2x.083db613.png";